import { render, staticRenderFns } from "./customTable.vue?vue&type=template&id=54575322&scoped=true&"
import script from "./customTable.vue?vue&type=script&lang=js&"
export * from "./customTable.vue?vue&type=script&lang=js&"
import style0 from "./customTable.vue?vue&type=style&index=0&id=54575322&prod&scoped=true&lang=less&"
import style1 from "./customTable.vue?vue&type=style&index=1&id=54575322&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54575322",
  null
  
)

export default component.exports